"use client";

import { Search } from "lucide-react";
import { useRouter } from "next/navigation";
import { useState } from "react";

export default function SearchForm() {
    const router = useRouter();
    const [query, setQuery] = useState("");

    const handleSearch = (e) => {
        e.preventDefault();
        if (query.trim()) {
            router.push(`/pros?search=${encodeURIComponent(query.trim())}`);
        }
    };

    return (
        <form onSubmit={handleSearch} className={"relative flex items-center"}>
            <input
                type="text"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="Quelle activité cherchez-vous ?"
                className={"w-full pl-12 pr-32 py-4 bg-white border border-gray-200 rounded-2xl shadow-sm focus:outline-none focus:ring-2 focus:ring-[#F0A202] transition-all"}
            />
            <Search className={"absolute left-4 text-primary"} size={20} />
            <button
                type="submit"
                className={"absolute right-2 bg-primary text-white px-6 py-2.5 rounded-xl font-semibold hover:bg-[#D1A400] transition-colors hidden sm:block"}
            >
                Rechercher
            </button>
        </form>
    );
}